import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'fc-file-processing-state',
  template: `
    <span class="flex flex-row align-center justify-center gap-4">
      <span
        class="inline-block rounded-full relative bg-primary-600 size-5 dot delay-0"
      ></span>
      <span
        class="inline-block rounded-full relative bg-primary-600 size-5 dot delay-2"
      ></span>
      <span
        class="inline-block rounded-full relative bg-primary-600 size-5 dot delay-4"
      ></span>
    </span>
  `,
  styles: `
    .dot {
      animation: jump 0.8s ease-in-out infinite;
    }
    .delay-0 {
      animation-delay: 0s;
    }
    .delay-2 {
      animation-delay: 0.15s;
    }
    .delay-4 {
      animation-delay: 0.3s;
    }

    @keyframes jump {
      0%,
      100% {
        transform: translateY(0) scale(1);
        opacity: 0.7;
      }
      50% {
        transform: translateY(-4px) scale(1.1);
        opacity: 1;
      }
    }
  `,
  host: {
    class: 'inline-flex h-full w-full items-center justify-center',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileProcessingStateComponent {}
